var _circle, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgImgLogoGoogle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 56,
  height: 56,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 28,
  r: 27.5,
  fill: "#fff",
  stroke: "#E6E9EE"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#img_logo_google_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M42.001 28.31c0-1.15-.095-1.99-.301-2.861H28.287v5.195h7.873c-.159 1.291-1.016 3.236-2.92 4.542l-.027.174 4.24 3.22.294.029c2.699-2.443 4.254-6.036 4.254-10.298Z",
  fill: "#4285F4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.286 42c3.857 0 7.095-1.245 9.46-3.391l-4.507-3.422c-1.207.824-2.826 1.4-4.953 1.4a8.584 8.584 0 0 1-8.127-5.818l-.167.014-4.41 3.344-.058.157C17.874 38.858 22.7 42 28.286 42Z",
  fill: "#34A853"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.16 30.769a8.463 8.463 0 0 1-.476-2.77c0-.964.174-1.897.46-2.768l-.008-.186-4.465-3.398-.146.068A13.786 13.786 0 0 0 14.001 28c0 2.256.556 4.386 1.524 6.284l4.635-3.515Z",
  fill: "#FBBC05"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.286 19.413c2.683 0 4.492 1.136 5.524 2.085l4.032-3.858C35.366 15.384 32.144 14 28.286 14c-5.587 0-10.412 3.142-12.762 7.715l4.62 3.516c1.158-3.376 4.365-5.818 8.142-5.818Z",
  fill: "#EB4335"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "img_logo_google_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(14.002 14)",
  d: "M0 0h28v28H0z"
})))));

export default SvgImgLogoGoogle;